/**
 * Nigerian School Calendar Utility
 * Handles term date ranges based on typical Nigerian school calendar
 */

// Nigerian school calendar typically follows this pattern:
// First Term: September - December
// Second Term: January - April  
// Third Term: May - July

export const getTermDateRanges = (year) => {
    return {
        'First Term': {
            start: new Date(year, 8, 1), // September 1st
            end: new Date(year, 11, 20)  // December 20th
        },
        'Second Term': {
            start: new Date(year + 1, 0, 10), // January 10th (next year)
            end: new Date(year + 1, 3, 15)    // April 15th (next year)
        },
        'Third Term': {
            start: new Date(year + 1, 4, 1), // May 1st (next year)
            end: new Date(year + 1, 6, 20)   // July 20th (next year)
        }
    };
};

export const getCurrentTerm = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    
    // Check if current date falls in previous academic year's third term
    const prevYearTerms = getTermDateRanges(currentYear - 1);
    if (now >= prevYearTerms['Third Term'].start && now <= prevYearTerms['Third Term'].end) {
        return 'Third Term';
    }
    
    // Check current academic year terms
    const currentYearTerms = getTermDateRanges(currentYear);
    
    if (now >= currentYearTerms['First Term'].start && now <= currentYearTerms['First Term'].end) {
        return 'First Term';
    } else if (now >= currentYearTerms['Second Term'].start && now <= currentYearTerms['Second Term'].end) {
        return 'Second Term';
    } else if (now >= currentYearTerms['Third Term'].start && now <= currentYearTerms['Third Term'].end) {
        return 'Third Term';
    }
    
    // Default to First Term if no match
    return 'First Term';
};

export const isNoteInCurrentTerm = (noteDate, selectedTerm, selectedSession) => {
    if (!noteDate || !selectedTerm || !selectedSession) return false;
    
    const noteDateTime = new Date(noteDate);
    const sessionYear = parseInt(selectedSession.split('/')[0]);
    const termRanges = getTermDateRanges(sessionYear);
    
    const termRange = termRanges[selectedTerm];
    if (!termRange) return false;
    
    return noteDateTime >= termRange.start && noteDateTime <= termRange.end;
};

export const categorizeNotes = (notes, selectedTerm, selectedSession) => {
    if (!notes || notes.length === 0) {
        return { currentNotes: [], olderNotes: [] };
    }
    
    const currentNotes = [];
    const olderNotes = [];
    
    notes.forEach(note => {
        if (isNoteInCurrentTerm(note.timestp, selectedTerm, selectedSession)) {
            currentNotes.push(note);
        } else {
            olderNotes.push(note);
        }
    });
    
    // Sort notes by date (newest first)
    const sortByDate = (a, b) => new Date(b.timestp) - new Date(a.timestp);
    
    return {
        currentNotes: currentNotes.sort(sortByDate),
        olderNotes: olderNotes.sort(sortByDate)
    };
};

export const getAcademicSession = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const month = now.getMonth();
    
    // If current month is September onwards, we're in new academic year
    if (month >= 8) { // September = 8
        return `${currentYear}/${currentYear + 1}`;
    } else {
        return `${currentYear - 1}/${currentYear}`;
    }
};